module.exports = __webpack_public_path__ + "static/media/logo-ripeurs-orange.d09fbd06.svg";